<template>
  <div class="fpd1">
    <div class="opo02">
      <span class="opo03">账户权限设置</span>
    </div>
    <div class="fpd2">
      <div class="fpd3">
        <div class="fpd5">
          <input type="text" placeholder="搜索用户" class="fpd4" v-model="userSea">
          <img src="../../assets/images/sea01.png" class="fpd6" alt="" @click="userSears">
        </div>
        <div class="fpd7" :style="'height:'+useHei+'px;'">
          <div class="fpd8" v-for="(item,index) in users.dataList" :key="'use'+index" :class="item.is_check ? 'fpd39':''" @click="xzUser(item,index)">
            <div class="fpd9">{{item.mobile}}</div>
            <div class="fpd10">{{item.name}}</div>
          </div>
          <div class="fpd36" v-if="userLoading == 4">
            <p class="fpd38">加载数据中...</p>
          </div>
          <div class="fpd36" v-if="userLoading == 2">
            <img src="../../assets/images/jiaz04.gif" class="fpd37" alt="">
            <p class="fpd38">加载中...</p>
          </div>
          <div class="fpd36" style="cursor: pointer" v-if="userLoading == 1" @click="upages()">
            <p class="fpd38">点击加载</p>
          </div>
          <div class="fpd36" v-if="userLoading == 3">
            <p class="fpd38">暂无更多</p>
          </div>
        </div>
      </div>
      <div class="fpd11">
        <div class="fpd12">
          <p class="fpd13">设备名称</p>
          <p class="fpd14" @click="qxSb">全选</p>
        </div>
        <div class="fpd7" :style="'height:'+sbHei+'px;'">
          <div class="fpd40" v-if="uindex === ''">未选中用户</div>
          <div class="fpd15" v-for="(item,index) in sblist" :key="'sbl'+index" @click="xzSb(item,index)">
            <p class="fpd16">{{item.name}}</p>
            <div class="fpd17">
              <img src="../../assets/images/icon22.png" class="fpd18" alt="" v-if="!item.hasOwnProperty('is_check') || item.is_check == false">
              <img src="../../assets/images/icon23.png" class="fpd18" alt="" v-else>
            </div>
          </div>
        </div>
      </div>
      <div class="fpd19">
        <div class="fpd20">
          <div class="fpd21">
            <input type="text" placeholder="搜索你想要查找的货物" class="fpd22" v-model="djSea">
            <div class="fpd23">
              <img src="../../assets/images/sea01.png" class="fpd24" alt="" @click="djSears">
            </div>
          </div>
          <div class="fpd25">
            <p class="fpd27" @click="zqxs">全部勾选</p>
            <div class="fpd26" @click="addData">保存</div>
          </div>
        </div>
        <div class="fpd28" :style="'height:'+useHei+'px;'">
          <div class="fpd40" v-if="djs.length == 0 && djLoading == false">未选中刀具柜</div>
          <div class="fpd41" v-if="djLoading">
            <img src="../../assets/images/jiaz04.gif" class="fpd37" alt="">
            <p class="fpd38">加载中...</p>
          </div>
          <div v-for="(item,index) in djs" :key="'djg'+index">
            <div class="fpd31">
              <div class="fpd29">{{item.devicename}}</div>
              <div class="fpd30" @click="djQx(item)">全选</div>
            </div>
            <div class="fpd32" v-for="(ite,ind) in item.data" :key="'dj'+ind">
              <div class="fpd33">{{ite.goodsname}}</div>
              <div class="fpd34">
                <span class="fpd45" @click="toXzs(ite,item)" v-if="ite.max_num === null || ite.max_num === ''">限制数量：未限制</span>
                <span class="fpd45" @click="toXzs(ite,item)" v-else>限制数量：{{ite.max_num}}</span>
                <img src="../../assets/images/icon22.png" class="fpd35" alt="" @click="xzDj(ite,ind,item)" v-if="ite.checked == 1">
                <img src="../../assets/images/icon23.png" class="fpd35" alt="" @click="xzDj(ite,ind,item)" v-else>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fpd42" v-show="is_qxLoading">
      <div class="fpd44">
        <img src="../../assets/images/jiaz04.gif" class="fpd43" alt="">
      </div>
    </div>
    <xc-model :loading="xzlModel" title="限制领取数量" :is_buttom="false" @cancel="xzl_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">数量：</div>
            <input v-model="xzNum" type="text" maxlength="6" placeholder="请输入领取数量" class="djt20">
          </div>
          <div class="djt21">
            <el-button style="line-height: 0" class="djt22" :loading="aduLoading" @click="xzlShur">确认</el-button>
            <div class="djt22" style="margin-left: 50px" @click="xzl_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from '@/api/user';
  import http from 'axios';
  import util from '@/util/util';
  import $ from 'jquery';
  export default {
    name: "fpdj",
    data(){
      return{
        useHei:'',
        sbHei:'',
        users:[],
        upage:1,
        upageSize:10,
        userLoading:4,/*1点击加载2加载中3暂无更多4加载初始数据*/
        uindex:'',
        sblist:[],
        sbindex:'',
        xzSbs:[],/*当前选中的设备*/
        isSbqx:false,
        djs:[],
        sear_djs:[],
        djLoading:false,
        dqDj:[],
        sbxb:[],/*选中设备保存设备下标*/
        is_qx:false,
        dqxzs:0,
        is_qxLoading:false,
        userSea:'',/*用户搜索关键词*/
        djSea:'',/*用户搜索刀具*/
        xzlModel:false,
        xzNum:0,
        aduLoading:false,
        lsIte:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      console.log(user);
    },
    mounted() {
      let hei1 = $('.fpd3').height();
      me.useHei = hei1-100;
      me.sbHei = hei1-115;

      let data = {
        mobile:user.mobile,
        sign:user.sign,
        page:me.upage,
        pageSize:me.upageSize,
        companyId:user.companyId,
      }
      let data1 = {
        companyid:user.companyId,
        pageSize:me.pageSize,
        page:1,
      }
      http.all([httpUser.userList(data),httpUser.djglist(data1)]).then(http.spread(function (res1,res2) {
        me.users = res1.data;
        me.users.dataList.forEach(function (item,index) {
          me.$set(item,'is_check',false);
        })
        me.userLoading = 1;
        console.log(res2);
        me.sblist = res2.data.dataList;
      }))
    },
    methods:{
      toXzs(ite,item){/*点击限制领取*/
        // console.log(ite);return;
        me.lsIte = ite;
        me.xzNum = ite.max_num;
        me.xzlModel = true;
      },
      xzl_cancel(){/*限制领取返回*/
        me.xzlModel = false;
      },
      xzlShur(){/*确认数量*/
        if (me.xzNum == null || me.xzNum == '') {
          me.$message.error('请输入领取数量');
          return false;
        }
        if (!util.is_num(me.xzNum)) {
          me.$message.error('领取数量应为数字类型');
          return false;
        }
        me.aduLoading = true;
        let data = {
          companyid:user.companyId,
          userid:me.users.dataList[me.uindex].id,
          list:[{
            goodsids:[me.lsIte.goodsid],
            deviceid:me.lsIte.deviceid,
            macNum:me.xzNum,
          }]
        }
        // console.log(data);return ;
        httpUser.updateMaxNumber(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                userid:me.users.dataList[me.uindex].id,
                deviceids:me.xzSbs,
                keyword:me.djSea,
              }
              httpUser.hqdj(data).then(res => {
                // console.log([me.dqDj,me.sbxb,res.data.datalist]);return false;
                me.djs = res.data.datalist;
                me.djs.forEach(function (item,index) {
                  if (me.sbxb[item.deviceid] != undefined) {
                    let i = 0;
                    item.data.forEach(function (ite,ind) {//循环刀具
                      if (me.dqDj[me.sbxb[item.deviceid]].goodsids.indexOf(ite.goodsid) != -1) {
                        i++;
                        ite.checked = 2;
                      }
                    })
                    if (i == item.data.length) {
                      me.$set(item,'is_check',true);
                    }
                  } else {
                    let arr = {
                      deviceid:item.deviceid,
                      goodsids:[],
                    };
                    item.data.forEach(function (ite,ind) {//循环刀具
                      if (ite.checked == 2) {
                        arr.goodsids.push(ite.goodsid);
                      }
                    })
                    if (arr.goodsids.length > 0) {
                      me.dqDj.push(arr);
                      me.sbxb[arr.deviceid] = me.dqDj.length-1;
                    }
                    if (arr.goodsids.length == item.data.length) {
                      me.$set(item,'is_check',true);
                      me.dqxzs++;
                    } else {
                      me.$set(item,'is_check',false);
                    }
                  }
                })
                me.aduLoading = false;
                me.xzlModel = false;
                me.$message.success('已设置');
              })
              break;
            case "1005":
              me.aduLoading = false;
              me.xzlModel = false;
              me.$message.error('未分配刀具权限');
              break;
          }
        })
      },
      djSears(){/*用户点击搜索刀具*/
        console.log(me.djs);
        if (me.uindex === '') {
          me.$message.error('请选择用户');
          return false;
        }
        me.djLoading = true;
        let data = {
          userid:me.users.dataList[me.uindex].id,
          deviceids:me.xzSbs,
          keyword:me.djSea,
        }
        httpUser.hqdj(data).then(res => {
          // console.log([me.dqDj,me.sbxb,res.data.datalist]);return false;
          me.djs = res.data.datalist;
          me.djs.forEach(function (item,index) {
            if (me.sbxb[item.deviceid] != undefined) {
              let i = 0;
              item.data.forEach(function (ite,ind) {//循环刀具
                if (me.dqDj[me.sbxb[item.deviceid]].goodsids.indexOf(ite.goodsid) != -1) {
                  i++;
                  ite.checked = 2;
                }
              })
              if (i == item.data.length) {
                me.$set(item,'is_check',true);
              }
            } else {
              let arr = {
                deviceid:item.deviceid,
                goodsids:[],
              };
              item.data.forEach(function (ite,ind) {//循环刀具
                if (ite.checked == 2) {
                  arr.goodsids.push(ite.goodsid);
                }
              })
              if (arr.goodsids.length > 0) {
                me.dqDj.push(arr);
                me.sbxb[arr.deviceid] = me.dqDj.length-1;
              }
              if (arr.goodsids.length == item.data.length) {
                me.$set(item,'is_check',true);
                me.dqxzs++;
              } else {
                me.$set(item,'is_check',false);
              }
            }
          })
          me.djLoading = false;
        })
      },
      userSears(){/*点击用户搜索*/
        me.users = [];
        me.userLoading = 2;
        me.uindex = '';
        me.djs = [];
        me.xzSbs = [];
        me.dqDj = [];
        me.dqxzs = 0;
        me.sbxb = [];
        me.sblist.forEach(function (item,index) {
          me.$set(item,'is_check',false);
        })
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          page:1,
          pageSize:me.upageSize,
          companyId:user.companyId,
          userName:me.userSea,
        }
        httpUser.userList(data).then(res => {
          console.log(res);
          res.data.dataList.forEach(function (item,index) {
            me.$set(item,'is_check',false);
          })
          me.users = res.data;
          if (res.data.totalNum == me.users.dataList.length) {
            me.userLoading = 3;
          } else {
            me.userLoading = 1;
          }
          console.log(me.users);
        })
      },
      addData(){/*保存用户权限*/
        // console.log(me.dqDj); return false;
        me.is_qxLoading = true;
        let data = {
          userid:me.users.dataList[me.uindex].id,
          cuserid:user.userId,
          companyid:user.companyId,
          list:me.dqDj,
        }
        // console.log(data);return;
        httpUser.saveData(data).then(res => {
          me.is_qxLoading = false;
          switch (res.code) {
            case "0000":
              me.$message.success('分配权限成功');
              break;
            case "1111":
              me.$message.error('分配失败，请稍后再试');
              break;
          }
        })
      },
      zqxs(){/*所有选中刀具柜下的刀具全部勾选或取消*/
        me.is_qxLoading = true;
        if (me.dqxzs == me.djs.length) {
          me.is_qx = true;
        }
        if (me.is_qx == false) {
          me.dqDj = [];
          me.sbxb = [];
          me.is_qx = true;
          me.djs.forEach(function (item,index) {
            item.is_check = true;
            let arr = {
              deviceid:item.deviceid,
              goodsids:[],
            };
            item.data.forEach(function (ite,ind) {
              ite.checked = 2;
              arr.goodsids.push(ite.goodsid);
            })
            if (arr.goodsids.length > 0) {
              me.dqDj.push(arr);
              me.sbxb[arr.deviceid] = me.dqDj.length-1;
            }
          })
          me.dqxzs = me.dqDj.length;
          me.is_qxLoading = false;
        } else {
          me.is_qx = false;
          me.djs.forEach(function (item,index) {
            item.is_check = false;
            item.data.forEach(function (ite,ind) {
              ite.checked = 1;
            })
          })
          me.dqDj.forEach(function (item,index) {
            item.goodsids = [];
          });
          // me.sbxb = [];
          me.dqxzs = 0;
          me.is_qxLoading = false;
        }
      },
      djQx(item){/*刀具全选或取消*/
        console.log(item);
        if (item.is_check == false) {
          item.is_check = true;
          if (me.sbxb[item.deviceid] != undefined) {
            if (me.sbxb[item.deviceid] > me.dqDj.length-1 || me.dqDj[me.sbxb[item.deviceid]].deviceid !== item.deviceid) {
              let arr = {
                deviceid:item.deviceid,
                goodsids:[],
              };
              me.dqDj.push(arr);
              me.sbxb[item.deviceid] = me.dqDj.length-1;
            }
            me.dqDj[me.sbxb[item.deviceid]].goodsids = [];
            item.data.forEach(function (e,i) {
              e.checked = 2;
              me.dqDj[me.sbxb[item.deviceid]].goodsids.push(e.goodsid);
            })
            me.dqxzs++;
          } else {
            let arr = {
              deviceid:item.deviceid,
              goodsids:[],
            };
            item.data.forEach(function (e,i) {
              e.checked = 2;
              arr.goodsids.push(e.goodsid);
            })
            me.dqDj.push(arr);
            me.sbxb[arr.deviceid] = me.dqDj.length-1;
            me.dqxzs++;
          }
        } else {
          item.is_check = false;
          item.data.forEach(function (e,i) {
            e.checked = 1;
          })
          me.dqDj[me.sbxb[item.deviceid]].goodsids = [];
          me.dqxzs--;
        }
        console.log(me.dqDj);
      },
      xzDj(ite,ind,item){/*选中或者取消刀具*/
        // console.log(me.dqDj[me.sbxb[ite.deviceid]]);return false;
        if (me.sbxb[ite.deviceid] != undefined) {
          if (ite.checked == 2) {
            if (me.dqDj[me.sbxb[ite.deviceid]].goodsids.length == item.data.length) {
              me.dqxzs--;
            }
            ite.checked = 1;
            item.is_check = false;
            me.dqDj[me.sbxb[ite.deviceid]].goodsids.splice(me.dqDj[me.sbxb[ite.deviceid]].goodsids.indexOf(ite.goodsid),1);
            // if (me.dqDj[me.sbxb[ite.deviceid]].goodsids.length == 0) {
            //   me.dqDj.splice(me.sbxb[ite.deviceid],1);
            // }
          } else {
            ite.checked = 2;
            if (me.sbxb[ite.deviceid] > me.dqDj.length-1 || me.dqDj[me.sbxb[ite.deviceid]].deviceid !== ite.deviceid) {
              let arr = {
                deviceid:item.deviceid,
                goodsids:[ite.goodsid],
              };
              me.dqDj.push(arr);
              me.sbxb[ite.deviceid] = me.dqDj.length-1;
            } else {
              me.dqDj[me.sbxb[ite.deviceid]].goodsids.push(ite.goodsid);
            }
            if (item.data.length == me.dqDj[me.sbxb[ite.deviceid]].goodsids.length) {
              item.is_check = true;
              me.dqxzs++;
            }
          }
        } else {
          ite.checked = 2;
          let arr = {
            deviceid:ite.deviceid,
            goodsids:[ite.goodsid],
          }
          me.dqDj.push(arr);
          me.sbxb[arr.deviceid] = me.dqDj.length-1;
          if (item.data.length == 1) {
            item.is_check = true;
            me.dqxzs++;
          }
        }
        console.log([me.sbxb,me.dqDj]);
      },
      qxSb(){/*设备全选或取消*/
        if (me.isSbqx == false) {
          me.xzSbs = [];
          me.dqDj = [];
          me.sbxb = [];
          me.sblist.forEach(function (item,index) {
            me.$set(item,'is_check',true);
            me.xzSbs.push(item.id);
          })
          me.isSbqx = true;
          me.djLoading = true;
          let data = {
            userid:me.users.dataList[me.uindex].id,
            deviceids:me.xzSbs,
            keyword:me.djSea,
          }
          httpUser.hqdj(data).then(res => {
            me.djs = res.data.datalist;
            me.djs.forEach(function (item,index) {
              let arr = {
                deviceid:item.deviceid,
                goodsids:[],
              };
              item.data.forEach(function (ite,ind) {
                if (ite.checked == 2) {
                  arr.goodsids.push(ite.goodsid);
                }
              })
              if (arr.goodsids.length > 0) {
                me.dqDj.push(arr);
                me.sbxb[arr.deviceid] = me.dqDj.length-1;
              }
              if (arr.goodsids.length == item.data.length) {
                me.$set(item,'is_check',true);
                me.dqxzs++;
              } else {
                me.$set(item,'is_check',false);
              }
            })
            me.djLoading = false;
          })
        } else {
          me.sblist.forEach(function (item,index) {
            me.$set(item,'is_check',false);
          })
          me.xzSbs = [];
          me.djs = [];
          me.dqDj = [];
          me.sbxb = [];
          me.dqxzs = 0;
          me.isSbqx = false;
        }
        console.log(me.dqDj);
      },
      xzSb(item,index){/*选中设备*/
        if (!item.hasOwnProperty('is_check') || item.is_check == false) {
          me.$set(item,'is_check',true);
          me.xzSbs.push(item.id);
          me.djLoading = true;
          let data = {
            userid:me.users.dataList[me.uindex].id,
            deviceids:[item.id],
            keyword:me.djSea,
          }
          httpUser.hqdj(data).then(res => {
            console.log(res,"??????");
            me.djs.push(res.data.datalist[0]);
            if (me.djs.length == me.sblist.length) {
              me.isSbqx = true;
            }
            if (res.data.datalist[0].data.length == 0) {
              me.djLoading = false;
              return false;
            }
            let arr = {
              deviceid:res.data.datalist[0].deviceid,
              goodsids:[],
            };
            res.data.datalist[0].data.forEach(function (item,index) {
              if (item.checked == 2) {
                arr.goodsids.push(item.goodsid);
              }
            })
            if (arr.goodsids.length > 0) {
              me.dqDj.push(arr);
              me.sbxb[arr.deviceid] = me.dqDj.length-1;
            }
            if (arr.goodsids.length == res.data.datalist[0].data.length) {
              me.$set(me.djs[me.djs.length-1],'is_check',true);
              me.dqxzs++;
            } else {
              me.$set(me.djs[me.djs.length-1],'is_check',false);
            }
            me.djLoading = false;
          })
        } else {
          item.is_check = false;
          let index = me.xzSbs.indexOf(item.id);
          me.xzSbs.splice(index,1);
          me.isSbqx = false;
          // console.log(me.dqDj[me.sbxb[item.id]]);return false;
          if (me.sbxb[item.id] !== undefined && me.sbxb[item.id] == me.dqDj.length-1 && me.dqDj[me.sbxb[item.id]].deviceid == item.id) {
            if (me.dqDj[me.sbxb[item.id]].goodsids.length == me.djs[index].data.lenth) {
              me.dqxzs--;
            }
            me.dqDj.splice(me.sbxb[item.id],1);
          }
          me.djs.splice(index,1);
        }
        console.log(me.dqDj);
      },
      xzUser(item,index){/*选中user*/
        console.log(me.xzSbs);
        if (me.uindex === '') {
          item.is_check = !item.is_check;
          me.uindex = index;
        } else {
          me.is_qxLoading = true;
          me.users.dataList[me.uindex].is_check = false;
          item.is_check = !item.is_check;
          me.uindex = index;
          me.dqDj = [];
          me.sbxb = [];
          me.djs = [];
          if (me.xzSbs.length > 0) {
            me.djLoading = true;
            let data = {
              userid:me.users.dataList[me.uindex].id,
              deviceids:me.xzSbs,
              keyword:me.djSea,
            }
            httpUser.hqdj(data).then(res => {
              // console.log(res);return false;
              me.djs = res.data.datalist;
              if (me.djs.length == me.sblist.length) {
                me.isSbqx = true;
              }
              me.djs.forEach(function (item,index) {
                let arr = {
                  deviceid:item.deviceid,
                  goodsids:[],
                };
                item.data.forEach(function (ite,ind) {
                  if (ite.checked == 2) {
                    arr.goodsids.push(ite.goodsid);
                  }
                })
                if (arr.goodsids.length > 0) {
                  me.dqDj.push(arr);
                  me.sbxb[arr.deviceid] = me.dqDj.length-1;
                }
                if (arr.goodsids.length == item.data.length) {
                  me.$set(item,'is_check',true);
                  me.dqxzs++;
                } else {
                  me.$set(item,'is_check',false);
                }
              })
              me.djLoading = false;
            })
          }
          me.is_qxLoading = false;
        }
        console.log(item);
      },
      upages(){/*用户列表分页*/
        me.userLoading = 2;
        me.upage++;
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          page:me.upage,
          pageSize:me.upageSize,
          companyId:user.companyId,
          userName:me.userSea,
        }
        httpUser.userList(data).then(res => {
          console.log(res);
          res.data.dataList.forEach(function (item,index) {
            me.$set(item,'is_check',false);
          })
          me.users.dataList = me.users.dataList.concat(res.data.dataList);
          console.log(me.users);
          if (res.data.totalNum == me.users.dataList.length) {
            me.userLoading = 3;
          } else {
            me.userLoading = 1;
          }
          console.log(me.users);
        })
      }
    }
  }
</script>

<style scoped>
@import "fpdj.css";
</style>